export const insuranceEs = {
  insurance: {
    title: "Seguros",
    subtitle: "Gestiona tus pólizas de seguro agrícola",
    activePolicies: "Pólizas Activas",
    claims: "Reclamaciones",
    coverage: "Cobertura",
    premium: "Prima",
    startDate: "Fecha de Inicio",
    endDate: "Fecha de Fin",
    status: "Estado",
    fileClaim: "Presentar Reclamación",
    viewPolicy: "Ver Póliza",
    renewPolicy: "Renovar Póliza",
    noPolicies: "Sin pólizas activas",
    getQuote: "Obtener Cotización"
  },
  insurancePage: {
    title: "Seguro Agrícola Inteligente",
    subtitle: "Protege tus inversiones en viñedos y olivares con un seguro con IA y monitoreo satelital que paga automáticamente cuando los cultivos están en riesgo.",
    howItWorks: "Cómo Funciona Nuestro Seguro",
    defineParcels: "Define Tus Parcelas",
    defineParcelsDesc: "Mapea los límites de tu viñedo u olivar con coordenadas GPS precisas. Nuestro sistema analiza tu tipo de cultivo, ubicación y riesgos históricos.",
    continuousMonitoring: "Monitoreo Continuo",
    continuousMonitoringDesc: "Las imágenes satelitales rastrean NDVI, humedad del suelo y patrones meteorológicos. Nuestra IA identifica patrones de estrés antes de que el daño sea visible.",
    automaticPayouts: "Pagos Automáticos",
    automaticPayoutsDesc: "Cuando los datos satelitales confirman estrés o daño en los cultivos, las reclamaciones se procesan automáticamente — sin papeleo, sin retrasos.",
    automaticPayoutsDescAlt: "Cuando los datos satelitales confirman daño en los cultivos por encima de los umbrales, los contratos inteligentes activan pagos instantáneos a tu billetera — sin papeleo.",
    whatWeCover: "Qué Cubrimos",
    vineyardInsurance: "Seguro de Viñedo",
    oliveGroveInsurance: "Seguro de Olivar",
    droughtStress: "Estrés por Sequía",
    frostDamage: "Daño por Helada",
    hailDamage: "Daño por Granizo",
    diseaseDetection: "Detección de Enfermedades",
    waterStress: "Estrés Hídrico",
    heatStress: "Estrés por Calor",
    windDamage: "Daño por Viento",
    pestDetection: "Detección de Plagas",
    coverageLevel: "Nivel de Cobertura",
    upToCoverage: "Hasta {{percent}}% del valor de producción",
    euRiskStandards: "Estándares de Evaluación de Riesgos UE",
    euRiskClassifications: "Clasificaciones de Riesgo de Seguros Europeos",
    lowRisk: "Riesgo Bajo",
    mediumRisk: "Riesgo Medio",
    highRisk: "Riesgo Alto",
    readyToProtect: "¿Listo para Proteger tus Cultivos?",
    readyToProtectDesc: "Únete a miles de agricultores que confían en Sentinel Crop para proteger sus inversiones agrícolas con tecnología blockchain compatible con la UE.",
    getStartedToday: "Comenzar Hoy"
  }
};
